import { Queries } from 'api/queries.enum'
import { GetInspirationalQuotesResponse } from 'api/actions/home/inspirationalQuotes/inspirationalQuotesActions.types'
import { getInspirationalQuotes } from 'api/actions/home/inspirationalQuotes/inspirationalQuotesActions'
import { useQuery } from 'hooks/useQuery'

export const useGetInspirationalQuotes = () => {
    const query = useQuery<GetInspirationalQuotesResponse, Error>({
        queryKey: [Queries.getInspirationalQuotes],
        queryFn: getInspirationalQuotes,
    })

    return query
}
